import React, { useEffect } from "react";
import moment from "moment";
import { connect } from "react-redux";

//Actions
import { monitoringList } from "../../../../../store/actions";
import { profile } from "routes/profile";
// styled components
import styled from "styled-components";
import {
  Container,
  Table,
  Header,
  HeaderCol,
  Title,
  Actionbar,
  Action,
  Body,
  BodyCol,
} from "../../../../parts/table/styled";
import TableFilter from "../../../../parts/table/filter/";
import Scrollbar from "../../../../parts/scrollbar/";

const Indicator = styled.div`
  width: 6px;
  height: 6px;
  background: ${(props) => props.color ?? "#989898"};
  margin-right: 8px;
  border-radius: 50%;
`;

export const userType = Object.keys(profile).reduce((prev, curr) => {
  prev[curr] = profile[curr].label;
  return prev;
}, {});
export const ramalStatus = {
  "": "-",
  available: "Disponível",
  logout: "Deslogado",
  on_call: "Em ligação",
  paused: "Em pausa",
};
const MonitoringTable = (props) => {
  const { width = "auto", margin = "0", status, t, monitoring } = props;
  const handleStatusTitle = () => {
    switch (status) {
      case "online":
        return { text: t?.online, color: "#6FCF97" };

      case "offline":
        return { text: t?.offline, color: "#ED856F" };

      case "pause":
        return { text: t?.pause, color: "#F2C94C" };

      case "idle":
        return { text: t?.idle, color: "#989898" };

      case "pre_break":
        return { text: t?.preBreak, color: "#989898" };
    }
  };

  const data = {
    title: handleStatusTitle(),

    header: [
      { key: "usuario", label: t?.header[0] },
      { key: "perfil", label: t?.header[1] },
      { key: "ramal_status", label: t?.header[2] },
      { key: "ultima_tabulacao", label: t?.header[3] },
      { key: "atendidos", label: t?.header[4] },
      { key: "aguardando_cliente", label: t?.header[5] },
      { key: "sla_vencido", label: t?.header[6], color: "#ED856F" },
      { key: "finalizados", label: t?.header[7] },
      { key: "positivo", label: t?.header[8] },
      { key: "negativo", label: t?.header[9] },
      { key: "neutro", label: t?.header[10] },
      { key: "primeiro_login", label: t?.header[11] },
      { key: "total_logado", label: t?.header[12] },
      { key: "total_atendido", label: t?.header[13] },
      { key: "total_pausado", label: t?.header[14] },
      { key: "descricao_pausa", label: t?.header[15] },
      { key: "tempo_pausa_atual", label: t?.header[16] },
      { key: "tempo_pre_pausa_atual", label: t?.header[17] },
      { key: "total_prepausado", label: t?.header[18] },
      { key: "nps_nota", label: t?.header[19] },
    ],
    rows: [],
  };

  const handleStatusRows = () => {
    const {
      monitoria_online,
      monitoria_offline,
      monitoria_pausados,
      monitoria_ociosos,
      monitoria_prepausados,
    } = monitoring;
    switch (status) {
      case "online":
        monitoria_online.map(({ perfil, ramal_status, ...x }) => {
          data.rows.push({
            perfil: userType[perfil],
            ramal_status: ramalStatus[ramal_status],
            ...x,
          });
        });
        break;

      case "offline":
        monitoria_offline.map(({ perfil, ramal_status, ...x }) => {
          data.rows.push({
            perfil: userType[perfil],
            ramal_status: ramalStatus[ramal_status],
            ...x,
          });
        });
        break;

      case "pause":
        monitoria_pausados.map(({ perfil, ramal_status, ...x }) => {
          data.rows.push({
            perfil: userType[perfil],
            ramal_status: ramalStatus[ramal_status],
            ...x,
          });
        });
        break;

      case "idle":
        monitoria_ociosos.map(({ perfil, ramal_status, ...x }) => {
          data.rows.push({
            perfil: userType[perfil],
            ramal_status: ramalStatus[ramal_status],
            ...x,
          });
        });
        break;
      case "pre_break":
        monitoria_prepausados.map(({ perfil, ramal_status, ...x }) => {
          data.rows.push({
            perfil: userType[perfil],
            ramal_status: ramalStatus[ramal_status],
            ...x,
          });
        });
        break;
      default:
        console.error("status not map => ", status);
        break;
    }
  };

  monitoring && handleStatusRows();

  const height =
    data.rows.length < 5 ? `${data.rows.length * 36 + 70}px` : "240px";

  return (
    data && (
      <Container margin={margin} boxShadow>
        <Actionbar>
          <Title color={data.title.color}>
            <Indicator color={data.title.color} />
            {`${data.title.text} - ${data.rows.length}`}
          </Title>

          <Action>{/* <TableFilter data={data} right /> */}</Action>
        </Actionbar>
        {data.rows.length > 0 && (
          <Scrollbar
            container={{ padding: "0 6px 6px 0", width: width, height: height }}
          >
            <Table>
              <Header>
                <tr>
                  {data.header.map((v, i) => (
                    <HeaderCol key={`header-${v.key}`} color={v.color}>
                      {v.label}
                    </HeaderCol>
                  ))}
                </tr>
              </Header>

              <Body>
                {data.rows.map((v, i) => (
                  <tr key={i}>
                    {data.header.map(({ key, color }) => (
                      <BodyCol key={`body-${key}-${i}`} color={color}>
                        {v[key]}
                      </BodyCol>
                    ))}
                  </tr>
                ))}
              </Body>
            </Table>
          </Scrollbar>
        )}
      </Container>
    )
  );
};

const mapStateToProps = (state) => ({
  currentTheme: state.auth.theme,
  monitoring: state.dash.monitoringList,
  t: state.i18nState.translations[state.i18nState.lang]["Dashboard"]["Tables"][
    "Monitoring"
  ],
});

const mapDispatchToProps = (dispatch) => ({
  getMonitoring: () => dispatch(monitoringList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MonitoringTable);
